import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";

import styles from "./AcademicActivites.module.css";

const BookPublications = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "bookPublications",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        bookTitle: "",
        publisher: "",
        year: "",
        ISBN: "",
      });
    }
  }, [fields, append]);

  return (
    <div className={styles.borderBox}>
      <div className={styles.heading}>
        <h2>2. Book Publications</h2>

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid4} key={item.id}>
          <Input
            label="Book Title"
            name={`bookPublications[${idx}].bookTitle`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Publisher"
            name={`bookPublications[${idx}].publisher`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Year"
            name={`bookPublications[${idx}].year`}
            register={register}
            errors={errors}
            year
            disabled={disabled}
          />
          <Input
            label="ISBN"
            name={`bookPublications[${idx}].ISBN`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}

      <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                bookTitle: "",
                publisher: "",
                year: "",
                ISBN: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default BookPublications;
